import React from "react";
import './demo.css'
import { useNavigate } from "react-router-dom";
import { PlayIcon } from "@heroicons/react/24/solid";

export default function Demo(){
    const navigate = useNavigate();

    return(
        <div className="demo_container  ">
        <div className="">
            <a href="https://www.youtube.com/channel/UCHACcQVpw_p0n03zZdSt4fg/videos" className="">


                <PlayIcon className="icon" />
            </a>

            <p className="">

                Watch Our Latest Video For Better Innovation
            </p>



        </div>
    </div>
    )
}